  (function(){
     let product_item = document.querySelectorAll('.grid_block__Classification')
     if(product_item<=0){
        return
     }
     product_item.forEach((ele)=>{
        let discount_code_ele = ele.querySelector('.discount_code')
        if(!discount_code_ele){
            return
        }
        let code = discount_code_ele.getAttribute('discount-code')
        ele.querySelector('.copy_icon').onclick=()=>{
          if(discount_code_ele.innerHTML == 'Copy Succeeded'){
              return
          }
          const input = document.createElement('textarea');
          document.body.appendChild(input);
          input.innerHTML = code;
          input.setAttribute('code',1);
          input.select();
          document.execCommand('copy');
          var list = document.getElementsByTagName('textarea');
          var inputList = Array.prototype.slice.call(list);
          inputList.forEach((item)=>{
              if(item.getAttribute('code'))document.body.removeChild(item);
          });

          discount_code_ele.innerHTML='Copy Succeeded'
          setTimeout(()=>{
            discount_code_ele.innerHTML=code
          },2000)
        }
     })
  })()